var commonStyles = {"component":"typography__component_lxn9e","bold":"typography__bold_lxn9e","semibold":"typography__semibold_lxn9e","medium":"typography__medium_lxn9e","regular":"typography__regular_lxn9e","rowLimit1":"typography__rowLimit1_lxn9e","rowLimit2":"typography__rowLimit2_lxn9e","rowLimit3":"typography__rowLimit3_lxn9e"};
require('./title/common.css')

export { commonStyles as c };
